<template>
  <FormSelect
    :name="'Province'"
    v-model:selected="selected"
    :options="options"
    :displayOptions="options"
  >
  </FormSelect>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { FormSelect } from '@/components'
import { Province } from '@/types/types'

//this macro creates a prop 'modelValue' and emits 'update:modelValue'
//const model = defineModel<Province>('selected');
const selected = defineModel<Province>('selected', { required: false })
//const selected = defineModel<Province>({ required : true, default : Province.AB });

//const prov = ref();
const options = [
  Province.AB,
  Province.BC,
  Province.SK,
  Province.MB,
  Province.ON,
  Province.NB,
  Province.NS
]

onMounted(() => {
  console.log('Province-select component mounted...')
})
</script>
